import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	personalInfo: null,
	loading: false,
	loadingSubmit: false
};

export default function personalParticularPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_REQUEST:
		case ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_ERROR:
		case ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_SUCCESS:
		case ActionTypes.SUBMIT_PERSONAL_PARTICULAR_REQUEST:
		case ActionTypes.SUBMIT_PERSONAL_PARTICULAR_ERROR:
		case ActionTypes.SUBMIT_PERSONAL_PARTICULAR_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_PERSONAL_PARTICULAR_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_PERSONAL_PARTICULAR_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
